import "./FilterComponent.css";
import React, { useEffect, useRef, useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { FaChevronDown, FaFilter } from "react-icons/fa";
import Select from "react-select";
import { provinces, utilities } from "../../../helpers/infoFilter";
import { getAllcompanies } from "../../../redux/apiCalls/companiesCall";
import { useDispatch, useSelector } from "react-redux";
import { getAllItemsBill } from "../../../redux/apiCalls/itemBills";
import { es } from "date-fns/locale";

// ✅ HOOK RESPONSIVE
const useIsMobile = (breakpoint = 850) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= breakpoint);
  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth <= breakpoint);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, [breakpoint]);
  return isMobile;
};

function FilterComponent({
  filterOptions,
  setFilterOptions,
  filterClass,
  setFilterClass,
  board,
}) {
  const dispatch = useDispatch();
  const menuRefs = useRef([]);
  const user = useSelector((state) => state.user.currentUser);
  const itemsBill = useSelector((state) => state.itemsBill.itemsBill);
  const suppliers = useSelector((state) => state.supplier.supplier);
  const companies = useSelector((state) => state.companies.companies);

  const isMobile = useIsMobile();
  const [showFilters, setShowFilters] = useState(false);
  const [activeFilter, setActiveFilter] = useState(null);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [classes, setClasses] = useState(null);
  const board1 = board?.board1[0]?.template;

  const orderCompanies = (companies || [])
    .reduce((acc, c) => {
      const name = c.name.trim();
      if (name) acc.push({ label: name, value: name });
      return acc;
    }, [])
    .sort((a, b) => a.label.localeCompare(b.label));

  useEffect(() => {
    getAllItemsBill(dispatch, user?.accessToken);
    getAllcompanies(dispatch, user?.accessToken);
  }, [dispatch]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      menuRefs.current.forEach((ref, index) => {
        if (ref && !ref.contains(event.target)) {
          if (activeFilter === index) setActiveFilter(null);
        }
      });

      if (
        showFilters &&
        !event.target.closest(".filter-container") &&
        !event.target.closest(".toggle-filter-btn")
      ) {
        setShowFilters(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [activeFilter, showFilters]);

  const handleFilterClick = (index) => {
    setActiveFilter((prev) => (prev === index ? null : index));
  };

  const handleProvinceChange = (selectedOptions) => {
    const values = selectedOptions?.map((o) => o.value) || [];
    setFilterOptions((prev) => ({ ...prev, provinces: values }));
    setActiveFilter(null);
  };

  const handleUtilityChange = (e) => {
    const value = e.target.value;
    const current = filterOptions.utilities || [];
    const updated = current.includes(value)
      ? current.filter((u) => u !== value)
      : [...current, value];

    const suppliersSelected = suppliers?.filter((s) =>
      updated.includes(s.servicio)
    );

    let unique = [
      ...new Set(
        itemsBill
          ?.filter(
            (item) =>
              suppliersSelected?.some((s) => s.nombre === item?.proveedor) &&
              item?.class !== "Total factura" &&
              item?.class !== "Total Factura"
          )
          ?.map((i) => i?.class)
      ),
    ].sort();

    if (updated.includes("GAS NATURAL")) {
      unique = [...new Set([...unique, "IVA"])];
    }

    setClasses(unique);
    setFilterClass({ class: filterClass.class.filter((c) => unique.includes(c)) });

    setFilterOptions({
      ...filterOptions,
      utilities: updated,
      ...(updated.length === 0 && { class: [] }),
    });

    if (updated.length === 0) setClasses(null);
  };

  const handleTypeChange = (e) => {
    const value = e.target.value;
    const selected = filterClass.class;
    const updated = selected.includes(value)
      ? selected.filter((v) => v !== value)
      : [...selected, value];
    setFilterClass({ ...filterClass, class: updated });
  };

  const handleLocationChange = (selectedOptions) => {
    const values = selectedOptions?.map((o) => o.value) || [];
    setFilterOptions((prev) => ({ ...prev, companies: values }));
    setActiveFilter(null);
  };

  const onChange = (date, isStart) => {
    if (!date) return;

    if (isStart) {
      setStartDate(date);
    } else {
      const end = new Date(date.getFullYear(), date.getMonth() + 1, 0);
      setEndDate(end);

      const startStr = `${startDate.getFullYear()}-${startDate.getMonth() + 1}-${startDate.getDate()}`;
      const endStr = `${end.getFullYear()}-${end.getMonth() + 1}-${end.getDate()}`;

      setFilterOptions({
        ...filterOptions,
        startDate: startStr,
        endDate: endStr,
      });

      localStorage.setItem(
        "SelectDates",
        JSON.stringify({ startDate: startStr, endDate: endStr })
      );
    }
  };

  const renderDateFilterMenu = (index) => (
    <div
      ref={(el) => (menuRefs.current[index] = el)}
      className={`filter-menu-picker date-filter-menu ${
        activeFilter === index ? "active" : ""
      }`}
    >
      <div>
        <label>Fecha inicio:</label>
        <DatePicker
          selected={startDate}
          onChange={(date) => onChange(date, true)}
          dateFormat="MM/yyyy"
          showMonthYearPicker
          selectsStart
          startDate={startDate}
          endDate={endDate}
          placeholderText="Mes inicio"
          minDate={new Date("2023-01-01")}
          maxDate={new Date()}
          locale={es}
        />
      </div>
      <div>
        <label>Fecha fin:</label>
        <DatePicker
          selected={endDate}
          onChange={(date) => onChange(date, false)}
          dateFormat="MM/yyyy"
          showMonthYearPicker
          selectsEnd
          startDate={startDate}
          endDate={endDate}
          minDate={startDate}
          maxDate={new Date()}
          placeholderText="Mes fin"
          locale={es}
        />
      </div>
    </div>
  );

  const renderFilterMenu = (label, options, index) => (
    <div
      ref={(el) => (menuRefs.current[index] = el)}
      className={`filter-menu ${activeFilter === index ? "active" : ""}`}
    >
      {label === "Tipo" && !classes ? (
        <label>Primero selecciona un servicio</label>
      ) : (
        [...new Set(options)].map((option) => (
          <label key={option.value || option}>
            <input
              type="checkbox"
              value={option.value || option}
              checked={
                label === "Provincia"
                  ? filterOptions.provinces.includes(option.value)
                  : label === "Utilidad"
                  ? filterOptions.utilities.includes(option)
                  : label === "Ubicación"
                  ? filterOptions.companies.includes(option)
                  : filterClass.class.includes(option)
              }
              onChange={
                label === "Provincia"
                  ? handleProvinceChange
                  : label === "Utilidad"
                  ? handleUtilityChange
                  : label === "Ubicación"
                  ? handleLocationChange
                  : label === "Tipo"
                  ? handleTypeChange
                  : undefined
              }
            />
            {label === "Provincia" ? option.name : option}
          </label>
        ))
      )}
    </div>
  );

  return (
    <>
      {isMobile && (
        <button
          className="toggle-filter-btn"
          onClick={() => setShowFilters((prev) => !prev)}
        >
          <FaFilter /> Filtros
        </button>
      )}

      <div
        className={`filter-container ${
          !isMobile || showFilters ? "visible" : "hidden"
        }`}
      >
        <div className="filter-button-container">
          <button
            className={`filter-button ${activeFilter === 0 ? "active" : ""}`}
            onClick={() => handleFilterClick(0)}
          >
            Período <i><FaChevronDown /></i>
          </button>
          {renderDateFilterMenu(0)}
        </div>

        <div className="filter-button-container">
          <Select
            isMulti
            placeholder="Provincia"
            options={provinces}
            components={{ DropdownIndicator: () => <FaChevronDown /> }}
            className="filter-button-select"
            onMenuOpen={() => setActiveFilter(null)}
            onChange={handleProvinceChange}
            value={provinces.filter((option) =>
              filterOptions.provinces.includes(option.value)
            )}
          />
        </div>

        <div className="filter-button-container filter-offices">
          <Select
            isMulti
            placeholder="Sucursal"
            options={orderCompanies}
            components={{ DropdownIndicator: () => <FaChevronDown /> }}
            className="filter-button-selected"
            onMenuOpen={() => setActiveFilter(null)}
            onChange={handleLocationChange}
            value={orderCompanies.filter((option) =>
              filterOptions.companies.includes(option.value)
            )}
          />
        </div>

        <div className="filter-button-container">
          <button
            className={`filter-button ${activeFilter === 3 ? "active" : ""}`}
            onClick={() => handleFilterClick(3)}
          >
            Servicio <i><FaChevronDown /></i>
          </button>
          {renderFilterMenu("Utilidad", utilities, 3)}
        </div>

        {board1 !== "templateC" && (
          <div className="filter-button-container">
            <button
              className={`filter-button ${activeFilter === 4 ? "active" : ""}`}
              onClick={() => handleFilterClick(4)}
            >
              Concepto <i><FaChevronDown /></i>
            </button>
            {renderFilterMenu("Tipo", classes, 4)}
          </div>
        )}
      </div>
    </>
  );
}

export default FilterComponent;
